import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sponsor-permits',
  templateUrl: './sponsor-permits.component.html',
  styleUrls: ['./sponsor-permits.component.scss']
})
export class SponsorPermitsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
